// The readout pill — stock, score, stage, wave (kit-sheet `.pill`,
// screen-mock `.pill`). A pill states a number; it is never a control.
//
// Translucent for the same reason `Panel` is: these sit over the board.

import { styled } from "@mui/material/styles";

export const Pill = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.kit.space.sm,
  background: `color-mix(in srgb, ${theme.kit.color.panelRaised} 85%, transparent)`,
  backdropFilter: "blur(4px)",
  border: `2px solid ${theme.kit.color.line}`,
  borderRadius: theme.kit.radius.pill,
  padding: "5px 13px",
  color: theme.kit.color.ink,
  fontFamily: theme.kit.font.body,
  fontWeight: 700,
  fontSize: 13
}));

/** The "STOCK" / "SCORE" cap on the left of a pill. */
export const PillLabel = styled("span")(({ theme }) => ({
  fontFamily: theme.kit.font.display,
  fontWeight: 600,
  fontSize: 10,
  letterSpacing: ".1em",
  textTransform: "uppercase",
  color: theme.kit.color.inkDim
}));
